import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';

export const PythonHighlighter = ({code, fontSize}) => {
    // eslint-disable-next-line prefer-const -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
    let safeFontSize = fontSize || "12px"
    return <div style={{fontSize:safeFontSize}}><SyntaxHighlighter language="python">{code}</SyntaxHighlighter></div>
}